export default __webpack_public_path__ + "static/media/my-img.dc88263d.png";